<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16"
  >
    <div class="px-6">
      <div class="flex flex-wrap justify-center">
        <div class="w-full px-4 flex justify-center">
          <div class="relative">
            <img
              alt="..."
              :src="this.user.avatar"
              class="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
            />
          </div>
        </div>
        <div class="w-full px-4 text-center mt-20">
          <div class="flex justify-center py-4 lg:pt-4 pt-8">
            <div class="mr-4 p-3 text-center">
              <span class="text-xl font-bold block uppercase tracking-wide text-gray-700">
                {{ this.user.roles.length }}
              </span>
              <span class="text-sm text-gray-500">Roles</span>
            </div>
            <div class="mr-4 p-3 text-center">
              <span class="text-xl font-bold block uppercase tracking-wide text-gray-700">
                {{ this.user.incidents.length }}
              </span>
              <span class="text-sm text-gray-500">Incidents</span>
            </div>
            <div class="mr-4 p-3 text-center">
              <span class="text-xl font-bold block uppercase tracking-wide text-gray-700">
                {{ this.user.teams.length }}
              </span>
              <span class="text-sm text-gray-500">Teams</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-12">
        <h3 class="text-xl font-semibold leading-normal mb-2 text-gray-700 mb-2">
          {{ this.user.first_name }} {{ this.user.middle_name}} {{ this.user.last_name }}
        </h3>
        <div class="text-sm leading-normal mt-0 mb-2 text-gray-700 font-bold uppercase">
          <i class="fas fa-map-marker-alt mr-2 text-lg text-gray-700"></i>
          City:
          {{ this.user.city == null ? "No current city" : this.user.city }}
        </div>
        <div class="text-sm leading-normal mt-0 mb-2 text-gray-700 font-bold uppercase">
          <i class="fas fa-map-marker-alt mr-2 text-lg text-gray-700"></i>
          Country:
          {{ this.user.country == null ? "No current country" : this.user.country }}
        </div>

        <div class="text-sm leading-normal mb-2 text-gray-700 font-bold uppercase">
          <i class="fas fa-pen-alt mr-2 mt-5 text-lg text-gray-700"></i>
          Created at:
          {{ this.user.created_at }}
        </div>
        <div class="text-sm leading-normal mb-2 text-gray-700 font-bold uppercase">
          <i class="fas fa-edit mr-2 text-lg text-gray-700"></i>
          Updated at:
          {{ this.user.updated_at }}
        </div>
        <div
          class="mb-2 text-gray-700 mt-10"
        >
          <i class="fas fa-user-tag mr-2 text-lg text-gray-500"></i>
          Roles: <strong>{{ this.roles }}</strong>
        </div>
      </div>
      <div class="mt-10 py-10 border-t border-gray-300 text-center">
        <div class="flex flex-wrap justify-center">
          <div class="w-full lg:w-9/12 px-4">
            <p class="mb-4 text-lg leading-relaxed text-gray-800">
              {{
                this.user.description == null
                  ? "The user has no description!"
                  : "Description: " + this.user.description
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="w-full xl:w-12/12 mb-5">
          <FormulateInput
            input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
            type="submit"
            @click="this.refreshUser"
            name="Refresh"
          />
        </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardProfile
  Description: This class representing a cards with user statistics and profile.
*/

/* Imports */
import RoleService from "@/services/role.service";
import UserService from "@/services/user.service";
/* /Imports/ */

export default {
  data () {
    return {
      user: {},
      timer: ''
    }
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },

    /* 
      Obtain user roles and modify them. 
    */
    roles() {
      return RoleService.showRoles(this.user.roles);
    }
  },

   /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call UserService class to get current user then update him if there is a change in data.
    */
    refreshUser() {
      UserService.getUser(this.currentUser.id).then((response) => {
        localStorage.setItem("user", JSON.stringify(response));

        this.user = JSON.parse(localStorage.getItem("user"));
      });
    },

    /* 
      Clear interval of timer for requests.
    */
    cancelAutoUpdate () {
      clearInterval(this.timer);
    },
  },
  
  /* 
    Cancel auto updating for optimization.
  */
  beforeDestroy () {
    this.cancelAutoUpdate();
  },

  /* 
    Check if user is authenticated and update him if there is a change in data.
  */
  created() {
    if (!this.user) {
      this.$router.push("/login");
    }

    this.refreshUser();

    this.timer = setInterval(this.refreshUser, 30000);
  },
};
</script>
